import React from 'react';
import Cleave from 'cleave.js/react';
import 'cleave.js/dist/addons/cleave-phone.br';

export default function MascaraTelefone(props) {
  const { inputRef, ...other } = props;
  return <Cleave htmlRef={inputRef} {...other} options={{ phone: true, phoneRegionCode: 'BR' }} />;
}
